"use strict";

// // Class definition
// var KTHomeRecruiterWidgets = function () {

//     // Mixed widgets
//     var initHomeWidget = function() {
//         var charts = document.querySelectorAll('.home-chart');

//         var color;
//         var strokeColor;
//         var height;
//         var labelColor = "#99A1B7";
//         var borderColor = "#F1F1F4";
//         var options;
//         var chart;

//         [].slice.call(charts).map(function(element) {
//             height = parseInt(KTUtil.css(element, 'height'));
//             color = "#1B84FF";
//             strokeColor = KTUtil.colorDarken(color, 15);

//             options = {
//                 series: [{
//                     name: 'Net Profit',
//                     data: [30, 45, 32, 70, 40, 40, 40]
//                 }],
//                 chart: {
//                     fontFamily: 'inherit',
//                     type: 'area',
//                     height: height,
//                     toolbar: {
//                         show: false
//                     },
//                     zoom: {
//                         enabled: false
//                     },
//                     sparkline: {
//                         enabled: true
//                     },
//                     dropShadow: {
//                         enabled: true,
//                         enabledOnSeries: undefined,
//                         top: 5,
//                         left: 0,
//                         blur: 3,
//                         color: strokeColor,
//                         opacity: 0.5
//                     }
//                 },
//                 plotOptions: {},
//                 legend: {
//                     show: false
//                 },
//                 dataLabels: {
//                     enabled: false
//                 },
//                 fill: {
//                     type: 'solid',
//                     opacity: 0
//                 },
//                 stroke: {
//                     curve: 'smooth',
//                     show: true,
//                     width: 3,
//                     colors: [strokeColor]
//                 },
//                 xaxis: {
//                     categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'],
//                     axisBorder: {
//                         show: false,
//                     },
//                     axisTicks: {
//                         show: false
//                     },
//                     labels: {
//                         show: false,
//                         style: {
//                             colors: labelColor,
//                             fontSize: '12px'
//                         }
//                     },
//                     crosshairs: {
//                         show: false,
//                         position: 'front',
//                         stroke: {
//                             color: borderColor,
//                             width: 1,
//                             dashArray: 3
//                         }
//                     }
//                 },
//                 yaxis: {
//                     min: 0,
//                     max: 80,
//                     labels: {
//                         show: false,
//                         style: {
//                             colors: labelColor,
//                             fontSize: '12px'
//                         }
//                     }
//                 },
//                 states: {
//                     normal: {
//                         filter: {
//                             type: 'none',
//                             value: 0
//                         }
//                     },
//                     hover: {
//                         filter: {
//                             type: 'none',
//                             value: 0
//                         }
//                     },
//                     active: {
//                         allowMultipleDataPointsSelection: false,
//                         filter: {
//                             type: 'none',
//                             value: 0
//                         }
//                     }
//                 },
//                 tooltip: {
//                     style: {
//                         fontSize: '12px',
//                     },
//                     y: {
//                         formatter: function (val) {
//                             return "$" + val + " thousands"
//                         }
//                     },
//                     marker: {
//                         show: false
//                     }
//                 },
//                 colors: ['transparent'],
//                 markers: {
//                     colors: [color],
//                     strokeColor: [strokeColor],
//                     strokeWidth: 3
//                 }
//             };

//             chart = new ApexCharts(element, options);
//             chart.render();  
//         });     
//     }

//     // Public methods
//     return {
//         init: function () {
//             // Mixed widgets
//             initHomeWidget();        
//         }   
//     }
// }();

// // Webpack support
// if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
//     module.exports = KTHomeRecruiterWidgets;
// }

// On document ready
KTUtil.onDOMContentLoaded(function() {
    // if($(".home-chart").length > 0){
    //     KTHomeRecruiterWidgets.init();
    // }

    $('#container-list-services').on('click', '.btn-request', function () {
        var btnRequest = $(this);
        btnRequest.addClass('disabled');
    })

    $('#home_request_access_modal').on('show.bs.modal', function() {
        var btnsRequest = $("#container-list-services").find(".btn-request");
        if (btnsRequest.length > 0) btnsRequest.removeClass('disabled');
    })

    $('#home_request_active_awareness_modal').on('click', '#request_active_awareness_btn', function () {
        var btnRequestAwarness = $(this);
        btnRequestAwarness.addClass('disabled');
    })

    $('#home_request_active_awareness_modal').on('hide.bs.modal', function () {
        $('#request_active_awareness_btn').removeClass('disabled');
    })

    $('#home_request_access_modal').on('click', '#request_service_btn,#request_access_admin_btn', function () {
        var btnRequestAccessModal = $(this);
        btnRequestAccessModal.addClass('disabled');
    })

    $(document).on('shown.bs.collapse', '#collapse-admins', function () {
        $('#toggle-admins-text').text('Ver menos administradores');
      });
      
      $(document).on('hidden.bs.collapse', '#collapse-admins', function () {
        $('#toggle-admins-text').text('Ver más administradores');
      });
      
});


  